module.exports = __webpack_public_path__ + "static/media/beeftomato.1592a707.webp";